module.exports = __webpack_public_path__ + "static/img/7-01.112bf85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7-01.png
// module id = 180
// module chunks = 1